import React from 'react';
import { Button, notification } from 'antd';

type NotificationType = 'success' | 'info' | 'warning' | 'error';
type NotificationPlacement =
  | 'top'
  | 'topLeft'
  | 'topRight'
  | 'bottom'
  | 'bottomLeft'
  | 'bottomRight';

interface INotificationWithButton {
  onClick: () => void;
  onClose: () => void;
  buttonText?: string;
  type?: NotificationType;
  title?: string;
  text?: string;
  durationSec?: number; // duration in seconds after witch the notification closes
  placement?: NotificationPlacement;
}

export const openNotification = ({
  onClick,
  onClose,
  buttonText,
  type = 'info',
  title,
  text,
  durationSec = 0,
  placement = 'bottomRight',
}: INotificationWithButton) => {
  const key = `open${Date.now()}`;

  const onClickHandler = () => {
    if (typeof onClick !== 'undefined' && typeof onClick == 'function') {
      onClick();
    }
    notification.close(key);
  };

  const onCloseHandler = () => {
    if (typeof onClose !== 'undefined' && typeof onClose == 'function') {
      onClose();
    }
  };

  const btn = (
    <Button type="primary" size="small" onClick={onClickHandler}>
      {buttonText}
    </Button>
  );

  notification[type]({
    message: title || '',
    description: text || '',
    key,
    onClose: onCloseHandler,
    duration: durationSec,
    placement,
    ...(buttonText && { btn }),
  });
};
